export default {
      id: "clock-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "app/svg/sprite.svg#clock",
      toString: function () {
        return this.url;
      }
    }